import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export const downloadPDF = async (reportRef, formData) => {
  if (!reportRef.current) return;
  
  // Store original styles for restoration
  const originalOverflow = reportRef.current.style.overflow;
  const originalHeight = reportRef.current.style.height;
  const originalMaxHeight = reportRef.current.style.maxHeight;
  const originalClassName = reportRef.current.className;
  
  try {
    // Show loading state
    console.log("Generating PDF... Please wait");
    
    // Hide the report header with buttons
    const reportHeader = reportRef.current.querySelector('.report-header');
    if (reportHeader) {
      reportHeader.style.display = 'none';
    }
    
    // Remove height restrictions to show all content
    reportRef.current.style.overflow = 'visible';
    reportRef.current.style.height = 'auto';
    reportRef.current.style.maxHeight = 'none';
    
    // Add PDF generation class for better styling
    reportRef.current.className = originalClassName + ' pdf-generation';
    
    // Wait a bit for the layout to adjust
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    // Capture the full content
    const canvas = await html2canvas(reportRef.current, {
      scale: 1.2, // Optimized scale for better quality and performance
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#ffffff',
      scrollX: 0,
      scrollY: 0,
      width: reportRef.current.scrollWidth,
      height: reportRef.current.scrollHeight,
      windowWidth: reportRef.current.scrollWidth,
      windowHeight: reportRef.current.scrollHeight,
      logging: false, // Disable console logging for cleaner output
      removeContainer: true // Remove the container element from the canvas
    });
    
    // Restore original styles
    reportRef.current.style.overflow = originalOverflow;
    reportRef.current.style.height = originalHeight;
    reportRef.current.style.maxHeight = originalMaxHeight;
    reportRef.current.className = originalClassName;
    
    // Show the report header again
    if (reportHeader) {
      reportHeader.style.display = '';
    }
    
    const imgData = canvas.toDataURL('image/png', 0.95);
    
    // Create PDF
    const pdf = new jsPDF('p', 'mm', 'a4');
    const imgWidth = 210; // A4 width in mm
    const pageHeight = 295; // A4 height in mm
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;
    
    let position = 0;
    
    // Add first page
    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;
    
    // Add additional pages if needed
    while (heightLeft >= 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }
    
    // Add metadata
    pdf.setProperties({
      title: `${formData.projectName || 'Business Value Calculator'} Report`,
      subject: 'Business Value Calculator Report',
      author: 'Traxccel Business Value Calculator',
      creator: 'Traxccel Platform',
      producer: 'Business Value Calculator'
    });
    
    // Generate filename with timestamp
    const timestamp = new Date().toISOString().split('T')[0];
    const filename = `${formData.projectName || 'Business_Value_Report'}_${timestamp}.pdf`;
    
    // Download the PDF
    pdf.save(filename);
    
    console.log("PDF generated successfully!");
    
  } catch (error) {
    console.error('Error generating PDF:', error);
    
    // Restore original styles in case of error
    reportRef.current.style.overflow = originalOverflow;
    reportRef.current.style.height = originalHeight;
    reportRef.current.style.maxHeight = originalMaxHeight;
    reportRef.current.className = originalClassName;
    
    // Show the report header again
    const reportHeader = reportRef.current.querySelector('.report-header');
    if (reportHeader) {
      reportHeader.style.display = '';
    }
    
    throw error;
  }
};
